import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NotificationManager } from 'react-notifications';
import { AvForm, AvField } from 'availity-reactstrap-validation';

import {
  Grid,
  Modal,
  Button,
  Form,
  Radio,
  Icon,
  Dimmer,
  Loader,
  Segment,
} from 'semantic-ui-react';

import { APP_NAME } from '../../utils/constant';

import {
  getActParticipantData,
  deleteActivityMember,
} from '../../store/actions';

import { CustomSegment, CustomTable, EmptyContainer } from '../../components';
import { PermissionDenied } from '../../components/errorStatus';
import { checkPermissionDenied } from '../../utils/activity/userPermission';

import { ActivityMember } from './form';

import './activities.scss';

export class ParticipantPermissionUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { participant, triggerComp, t } = this.props;
    const { modal } = this.state;
    return (
      <div className="add-goal-custom">
        <Modal
          onOpen={() => this.toggle()}
          trigger={triggerComp}
          size="tiny"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="edit-guest-user-modal"
        >
          <Modal.Header>
            {t('activity.participants.edit_permission_of', {
              name: participant.user ? participant.user.name : '-',
            })}
          </Modal.Header>
          <Modal.Content>
            <ActivityMember
              className="permission-pop-up"
              editPermission
              toggle={() => this.toggle()}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class ActivityParticipantCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <div className="add-goal">
        <Modal
          onOpen={() => this.toggle()}
          trigger={
            <Button className=" Primary-Button">
              <Icon name="plus circle" />
              {t('activity.participants.invite_user')}
            </Button>
          }
          size="tiny"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="add-guest-user-modal"
        >
          <Modal.Header>
            {t('activity.participants.add_guest_user')}
          </Modal.Header>
          <Modal.Content>
            <ActivityMember
              toggle={() => this.toggle()}
              {...this.props}
              inviteUser={true}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

export class ParticipantDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
      removeFromList: false,
      notifyMember: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      removeFromList: false,
      notifyMember: false,
    }));
  }

  async handleValidSubmit(event, values) {
    const { t, deleteActivityMember, participant } = this.props;
    const { removeFromList, notifyMember } = this.state;
    this.setState({ loading: true });
    try {
      await deleteActivityMember(participant, {
        message: notifyMember ? values.message : null,
        notifyMember,
        removeFromList,
      });
      this.setState({ loading: false });
      NotificationManager.success(
        t('activity.participants.user_was_removed_from_the_activity'),
        t('activity.participants.participant_remove_success')
      );
      this.toggle();
    } catch (error) {
      this.setState({ loading: false });
      NotificationManager.error(
        t('activity.participants.we_couldnt_delete_the_activity'),
        t('common.something_went_wrong')
      );
    }
  }

  render() {
    const { modal, loading, removeFromList, notifyMember } = this.state;
    const { participant, triggerComp, t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="small"
        trigger={triggerComp}
      >
        <Modal.Header>
          {t('activity.participants.withdraw_member')} -{' '}
          {participant.user ? participant.user.name : '-'}
        </Modal.Header>
        <Modal.Content>
          <AvForm
            ref={(c) => (this.form = c)}
            onValidSubmit={(event, values) =>
              this.handleValidSubmit(event, values)
            }
          >
            <Form.Field className="withdraw-radio-group">
              <Radio
                label={t('activity.participants.leave_withdrawn_in_list')}
                checked={!removeFromList}
                onChange={() => this.setState({ removeFromList: false })}
              />
            </Form.Field>
            <Form.Field className="withdraw-radio-group">
              <Radio
                label={t('activity.participants.remove_withdrawn_from_list')}
                checked={removeFromList}
                onChange={() => this.setState({ removeFromList: true })}
              />
            </Form.Field>
            <div className="withdraw-notify-toggle">
              <div className="withdraw-notify-label">
                {t('activity.participants.notify_member')}
              </div>
              <div className="checkbox-container auto-width">
                <div className="button-include">
                  <Button.Group className="btn">
                    <Button
                      type="button"
                      active={!notifyMember}
                      onClick={() => this.setState({ notifyMember: false })}
                    >
                      {t('actions.no')}
                    </Button>
                    <Button
                      type="button"
                      active={notifyMember}
                      onClick={() => this.setState({ notifyMember: true })}
                    >
                      {t('actions.yes')}
                    </Button>
                  </Button.Group>
                </div>
              </div>
            </div>
            {notifyMember && (
              <AvField
                label={t('activity.participants.message_to_member')}
                className="org-inputs-textarea"
                name="message"
                type="textarea"
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'activity.participants.message_is_required'
                    ),
                  },
                }}
              />
            )}
            <div className="participant-delete-button-container">
              <Button
                type="button"
                onClick={() => this.toggle()}
                className="modal-cancel"
              >
                {t('actions.cancel')}
              </Button>
              <Button
                className="modal-proceed"
                content={t('activity.participants.withdraw_confirm')}
                type="submit"
                loading={loading}
                disabled={loading}
              />
            </div>
          </AvForm>
        </Modal.Content>
      </Modal>
    );
  }
}

class Participants extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      columns: [
        {
          title: '',
          render: (data) => {
            return (
              <div className="participant-users-container">
                <label className="participant-users-mainText">
                  {data.user ? data.user.name : '-'}
                </label>
                <label className="participant-users-text">
                  <b>{t('activity.participants.type')}:</b>
                  {this.props.currentActivity.ownerId === data.userId
                    ? t('activity.participants.owner')
                    : this.renderUserType(data.user)}
                </label>
              </div>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            return (
              <label className="participant-users-text">
                <b>{t('activity.participants.email')}:</b>
                {data.user ? data.user.email : '-'}
              </label>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            if (this.props.currentActivity.ownerId === data.userId) return null;
            return (
              <label className="participant-users-text">
                <b>{t('activity.participants.invitation_status')}:</b>
                <span className="invitation-status">
                  {data.status ? data.status : '-'}
                </span>
              </label>
            );
          },
        },
        {
          title: '',
          render: (data) => {
            // TAK-2080: the manager can change any other member's permissions,
            // before or after they accept (reverses a Nov 2025 change that
            // showed this on the manager's own row only)
            const { currentActivity, user } = this.props;
            if (currentActivity.ownerId === data.userId) return null;
            if (data.status === 'withdrawn') return null;
            if (user.id !== currentActivity.ownerId) return null;
            return (
              <div className="activity-actions">
                <ParticipantPermissionUpdate
                  triggerComp={
                    <label className="activity-actions-warn">
                      {t('activity.participants.update_permission')}
                    </label>
                  }
                  participant={data}
                  {...this.props}
                />
                <ParticipantDelete
                  participant={data}
                  triggerComp={
                    <label className="activity-actions-error first-down">
                      {t('activity.participants.remove_participant')}
                    </label>
                  }
                  {...this.props}
                />
              </div>
            );
          },
        },
      ],
    };
  }

  renderUserType(user) {
    const { t } = this.props;
    switch (user.role) {
      case 'admin':
        return t('role.super_admin');
      case 'organisationAdmin':
        return t('role.organisation_admin');
      case 'user':
        return t('role.user');
      case 'guest':
        return t('role.guest');
      default:
        return '-';
    }
  }

  getColumns(currentActivity, user) {
    const { t } = this.props;
    return [
      {
        width: 4,
        title: t('activity.participants.member_name'),
        render: (data) => {
          return (
            <div className="current-member-wrapper">
              <div className="current-member-text">
                {data.user ? (data.user.name ? data.user.name : null) : null}
              </div>
              {data.isOwner ? (
                <div className="activity-owner">
                  {t('activity.participants.activity_manager')}
                </div>
              ) : null}
            </div>
          );
        },
      },
      {
        width: 4,
        title: t('activity.participants.email'),
        render: (data) => {
          return (
            <>{data.user ? (data.user.email ? data.user.email : null) : null}</>
          );
        },
      },
      {
        width: 3,
        title: t('activity.participants.permission'),
        render: (data) => {
          return (
            <>
              {data.permissions[0].permission.read === true &&
              data.permissions[0].permission.write === true &&
              data.permissions[1].permission.read === true &&
              data.permissions[1].permission.write === true &&
              data.permissions[2].permission.read === true &&
              data.permissions[2].permission.write === true &&
              data.permissions[3].permission.read === true &&
              data.permissions[3].permission.write === true &&
              data.permissions[4].permission.read === true &&
              data.permissions[4].permission.write === true &&
              data.permissions[5].permission.read === true &&
              data.permissions[5].permission.write === true &&
              data.permissions[6].permission.read === true &&
              data.permissions[6].permission.write === false &&
              data.permissions[7].permission.read === true &&
              data.permissions[7].permission.write === true &&
              data.permissions[8].permission.read === true &&
              data.permissions[8].permission.write === false
                ? t('permission_type.collaborator')
                : data.permissions[0].permission.read === false &&
                    data.permissions[0].permission.write === false &&
                    data.permissions[1].permission.read === false &&
                    data.permissions[1].permission.write === false &&
                    data.permissions[2].permission.read === false &&
                    data.permissions[2].permission.write === false &&
                    data.permissions[3].permission.read === false &&
                    data.permissions[3].permission.write === false &&
                    data.permissions[4].permission.read === false &&
                    data.permissions[4].permission.write === false &&
                    data.permissions[5].permission.read === false &&
                    data.permissions[5].permission.write === false &&
                    data.permissions[6].permission.read === true &&
                    data.permissions[6].permission.write === false &&
                    data.permissions[7].permission.read === true &&
                    data.permissions[7].permission.write === true &&
                    data.permissions[8].permission.read === true &&
                    data.permissions[8].permission.write === false
                  ? t('permission_type.documentor')
                  : data.permissions[0].permission.read === false &&
                      data.permissions[0].permission.write === false &&
                      data.permissions[1].permission.read === false &&
                      data.permissions[1].permission.write === false &&
                      data.permissions[2].permission.read === false &&
                      data.permissions[2].permission.write === false &&
                      data.permissions[3].permission.read === false &&
                      data.permissions[3].permission.write === false &&
                      data.permissions[4].permission.read === false &&
                      data.permissions[4].permission.write === false &&
                      data.permissions[5].permission.read === false &&
                      data.permissions[5].permission.write === false &&
                      data.permissions[6].permission.read === false &&
                      data.permissions[6].permission.write === false &&
                      data.permissions[7].permission.read === false &&
                      data.permissions[7].permission.write === false &&
                      data.permissions[8].permission.read === true &&
                      data.permissions[8].permission.write === false
                    ? t('permission_type.report_only')
                    : t('permission_type.custom')}
            </>
          );
        },
      },
      {
        width: 2,
        title: t('common.status'),
        render: (data) => {
          return (
            <div>
              {currentActivity.ownerId === data.userId ? (
                <div className="member-role">
                  {t('activity.participants.activity_manager')}
                </div>
              ) : data.status.charAt(0).toUpperCase() + data.status.slice(1) ? (
                <div className="member-role">
                  {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                </div>
              ) : null}
            </div>
          );
        },
      },
      {
        width: 3,
        title: '',
        render: (data) => {
          return (
            <>
              {/* TAK-2080: the manager edits other members' permissions,
                  pending or accepted */}
              {currentActivity.ownerId !== data.userId &&
              data.status !== 'withdrawn' &&
              user.id === currentActivity.ownerId ? (
                <ParticipantPermissionUpdate
                  triggerComp={
                    <label className="default-color mb-0">
                      {t('activity.participants.update_permission')}
                    </label>
                  }
                  participant={data}
                  {...this.props}
                />
              ) : null}
            </>
          );
        },
      },
      {
        width: 2,
        title: '',
        render: (data) => {
          return (
            <>
              {currentActivity.ownerId !== data.userId &&
              data.status !== 'withdrawn' &&
              user.id === currentActivity.ownerId ? (
                <ParticipantDelete
                  participant={data}
                  triggerComp={
                    <label className="activity-actions-error first-down mb-0">
                      {t('actions.remove')}
                    </label>
                  }
                  {...this.props}
                />
              ) : null}
            </>
          );
        },
      },
    ];
  }

  render() {
    const { data, actGetLoading, actPut, currentActivity, user } = this.props;
    if (actGetLoading) return null;
    return (
      <Segment
        className="content-segment-custom"
        loading={actPut.activityMembers ? true : false}
      >
        <CustomTable
          header
          columns={this.getColumns(currentActivity, user)}
          data={data}
          customClass="evidence-table-grant"
          keyExtractor={(item, index) => item.id}
        />
      </Segment>
    );
  }
}

class ActivityParticipants extends PureComponent {
  async componentDidMount() {
    const { t } = this.props;
    document.title = `${t('common.activities')} | ${APP_NAME}`;

    try {
      const { match, getActParticipantData } = this.props;

      if (match.params) {
        await getActParticipantData(match.params.id);
      }
    } catch (error) {
      // console.error('ActivitySteps -> componentDidMount -> error', error);
    }
  }

  render() {
    const { currentActivity, actGetLoading, actMembers, user, t } = this.props;
    if (checkPermissionDenied(user, currentActivity))
      return <PermissionDenied />;

    return (
      <div className="content-layer">
        <div className="content-container">
          <Grid>
            <Grid.Row className="act-row">
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={8}
                // className="activity-sub-column"
              >
                {/* <div className="act-participant-container">
                  <label className="act-participant-title">
                    <strong>Activity:</strong>{' '}
                    {currentActivity ? currentActivity.name : '-'}
                  </label>
                </div> */}
              </Grid.Column>
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={8}
                className="activity-sub-column"
                f
              >
                <ActivityParticipantCreate {...this.props} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="act-row">
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={16}
                className="activity-sub-column"
              >
                <CustomSegment
                  title={t('activity.participants.manage_activity_members')}
                  extraMargin
                  children={
                    actMembers && actMembers.length ? (
                      <Participants data={actMembers} {...this.props} />
                    ) : (
                      <EmptyContainer
                        msg={t(
                          'activity.participants.you_have_not_created_any_participants_yet'
                        )}
                      />
                    )
                  }
                  toggle={false}
                  className="manage-activity-members"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
        <Dimmer active={actGetLoading} inverted>
          <Loader size="massive" />
        </Dimmer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    user: state.authentication.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getActParticipantData,
      deleteActivityMember,
    },
    dispatch
  );
};

ActivityParticipants = withTranslation()(ActivityParticipants);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityParticipants);
